<template>
	<Form ref="formValidate" :model="formValidate" :label-width="110" :label-colon="true">
		<Row>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="创建日期">
				<DatePicker type="daterange" v-model="formValidate.dateRange" :options="dateRangeOptions"
					format="yyyy/MM/dd" placement="bottom-start" placeholder="请选择" clearable />
			</FormItem>
			</Col>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="主渠道编码">
				<Select v-model="formValidate.mainChannelCode" style="width:200px" clearable
					@on-change="chooseMainChannel">
					<Option v-for="item in mianChannels" :value="item" :key="item">{{ item }}
					</Option>
				</Select>
			</FormItem>
			</Col>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="子渠道编码">
				<Select v-model="formValidate.channelId" style="width:200px" clearable>
					<Option v-for="item in childChannels" :value="item.id" :key="item.id">{{ item.childChannelCode }}
					</Option>
				</Select>
			</FormItem>
			</Col>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem>
				<Button type="primary" @click="formSubmit" icon="md-search" style="margin: 0 8px 16px 0px;">查询</Button>
			</FormItem>
			</Col>
		</Row>
	</Form>

</template>
<script>
	import api from '../../api'
	import {
		mapGetters
	} from 'vuex'
	import {
		STATISTICS_START_TIME,
		LINK_TYPES
	} from '../../config/constants'

	export default {
		name: 'QueryCondition',
		props: {

		},
		data() {
			return {
				mianChannels: [],
				childChannels:[],
				formValidate: {
					dateRange: [],
					mainChannelCode: undefined,
					channelId: undefined,
				},
				dateRangeOptions: {
					disabledDate(date) {
						const startDate = new Date(STATISTICS_START_TIME).getTime()
						const now = Date.now()
						return (
							date && !(date.valueOf() >= startDate && date.valueOf() <= now)
						)
					}
				}
			}
		},
		computed: {
			...mapGetters('statistics', ['accountGroup', 'pageStatus'])
		},
		mounted() {
			//获取全部主渠道
			api.statistics
				.allMainChannel()
				.then(res => {
					this.mianChannels = res.data
				})
		},
		methods: {
			formSubmit() {
				this.$emit('query', this.getFormData())
			},
			exportExcel() {
				this.$emit('exportExcel', this.getFormData())
			},
			formReset() {
				this.$refs['formValidate'].resetFields()
				this.formValidate = {}
				//this.formSubmit()
			},
			getFormData() {
				let beginTime = this.formValidate.dateRange[0] || null
				let endTime = this.formValidate.dateRange[1] || null
				const formData = {
					beginTime: beginTime ? this.util.formatDateTime(beginTime) : null,
					endTime: endTime ? this.util.dateFormat(endTime, 'yyyy-MM-dd') + ' 23:59:59' : null,
					mainChannelCode: this.formValidate.mainChannelCode,
					channelId: this.formValidate.channelId,
				}
				return formData
			},
			chooseMainChannel(value) {
				if(value){
					api.statistics
						.allChildChannel(value)
						.then(res => {
							this.childChannels = res.data
						})
				}else{
					this.childChannels=[]
					this.formValidate.channelId=undefined
				}
			
			}
		}
	}
</script>